export const form200 = [
  {
    type: "header",
    formnum: "200.00",
    text:
      "ДЕКЛАРАЦИЯ ПО ИНДИВИДУАЛЬНОМУ ПОДОХОДНОМУ НАЛОГУ И СОЦИАЛЬНОМУ НАЛОГУ",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  { type: "title", text: "ИНФОРМАЦИЯ ПО РАБОТНИКАМ" },
  // addWorkers
  { type: "field", ftype: 7 },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  { type: "title", text: "Раздел. Расчетные показатели" },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.00.001",
    text:
      "Сумма индивидуального подоходного налога, подлежащего уплате в бюджет",
    fieldnum: "F001",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.002",
    text:
      "Сумма обязательных пенсионных взносов, подлежащих перечислению за работников",
    fieldnum: "F002",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.003",
    text:
      "Сумма обязательных профессиональных пенсионных взносов, подлежащих перечислению за работников",
    fieldnum: "F003",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.004",
    text:
      "Сумма обязательных пенсионных взносов, подлежащих перечислению в свою пользу",
    fieldnum: "F004",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.005",
    text:
      "Сумма социального налога, подлежащего уплате в бюджет с применением ставок, установленных пунктом 1 статьи 485 Налогового кодекса",
    fieldnum: "F005",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.006",
    text:
      "Сумма социального налога с учетом особенности, установленной статьей 700 Налогового кодекса",
    fieldnum: "F006",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.007",
    text:
      "Сумма социального налога, подлежащего уплате в бюджет с применением ставок, установленных пунктом 2 статьи 485 Налогового кодекса",
    fieldnum: "F007",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.008",
    text: "Сумма социальных отчислений с доходов работников",
    fieldnum: "F008",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.009",
    text: "Сумма социальных отчислений в свою пользу",
    fieldnum: "F009",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.010",
    text: "Сумма отчислений на обязательное социальное медицинское страхование",
    fieldnum: "F010",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.00.011",
    text: "Сумма взносов на обязательное социальное медицинское страхование",
    fieldnum: "F011",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "header",
    formnum: "200.01",
    text:
      "ИСЧИСЛЕНИЕ ИНДИВИДУАЛЬНОГО ПОДОХОДНОГО НАЛОГА И СОЦИАЛЬНОГО НАЛОГА, ОБЯЗАТЕЛЬНЫХ ПЕНСИОННЫХ ВЗНОСОВ, ОБЯЗАТЕЛЬНЫХ ПРОФЕССИОНАЛЬНЫХ ПЕНСИОННЫХ ВЗНОСОВ, СОЦИАЛЬНЫХ ОТЧИСЛЕНИЙ (Приложение 1 к Декларации)",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  { type: "title", text: "Раздел. Индивидуальный подоходный налог" },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.01.001",
    text: "Начисленные доходы",
    fieldnum: "F01001",
  },
  { type: "field", num: "", text: "text", fieldnum: "" },
  { type: "field", num: "", text: "text", fieldnum: "" },
  {
    type: "field",
    ftype: 1,
    num: "200.01.002",
    text:
      "Сумма индивидуального подоходного налога, исчисленного с начисленных доходов",
    fieldnum: "F01002",
  },
  {
    type: "field",
    ftype: 0,
    num: "200.01.003",
    text: "Задолженность по доходам, невыплаченным физическим лицам",
    fieldnum: "F01003",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "200.01.004",
    text:
      "Индивидуальный подоходный налог по доходам, начисленным, но не выплаченным на начало отчетного квартала",
    fieldnum: "F01004",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "200.01.005",
    text:
      "Индивидуальный подоходный налог по доходам, начисленным, но не выплаченным на конец отчетного кварталаы",
    fieldnum: "F01005",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.01.006",
    text: "Выплачено доходов",
    fieldnum: "F01006",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text:
      "Раздел. Обязательные пенсионные взносы, обязательные профессиональные пенсионные взносы",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.01.007",
    text: "Выплачено доходов",
    fieldnum: "F01007",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.01.008",
    text: "Выплачено доходов",
    fieldnum: "F01008",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.01.009",
    text: "Выплачено доходов",
    fieldnum: "F01009",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text: "Раздел. Численность и расходы по оплате труда работников-инвалидов",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 3,
    num: "200.01.010",
    text: "Численность работников-инвалидов",
    fieldnum: "F01010",
  },
  {
    type: "field",
    ftype: 3,
    num: "200.01.011",
    text:
      "Удельный вес численности работников-инвалидов в общей численности работников, %",
    fieldnum: "F01011",
  },
  {
    type: "field",
    ftype: 3,
    num: "200.01.012",
    text:
      "Удельный вес расходов по оплате труда работников-инвалидов в общих расходах по оплате труда, %",
    fieldnum: "F01012",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text:
      "Раздел. Социальный налог с применением ставок, установленных пунктом 1 статьи 485 Налогового кодекса",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.01.013",
    text: "Доходы работника, облагаемые социальным налогом",
    fieldnum: "F01013",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text: "Раздел. Социальные отчисления",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.01.014",
    text: "Доходы физических лиц, с которых исчисляются социальные отчисления",
    fieldnum: "F01014",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.01.015",
    text: "Доход, с которого исчисляются социальные отчисления в свою пользу",
    fieldnum: "F01015",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text:
      "Раздел. Отчисления и (или) взносы на обязательное социальное медицинское страхование",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 1,
    num: "200.01.016",
    text:
      "Доходы, с которых исчисляются отчисления на обязательное социальное медицинское страхование",
    fieldnum: "F01016",
  },
  {
    type: "field",
    ftype: 1,
    num: "200.01.017",
    text:
      "Доходы, с которых исчисляются взносы на обязательное социальное медицинское страхование",
    fieldnum: "F01017",
  },
]
